import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-members-add',
  templateUrl: './plan-members-add.component.html',
  styleUrls: ['./plan-members-add.component.scss']
})
export class PlanMembersAddComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
